module.exports = __webpack_public_path__ + "static/media/categoryMaster.23a670e9.svg";